<style lang="scss" type="stylesheet/scss" scoped>
.publish-product {
  padding-bottom: 20px;
  background: #eff0f4;
  .publish-product-inner {
    padding: 22px;
    .publish-product-title {
      font-size: 14px;
      color: #333;
      margin-bottom: 22px;
    }
  }
}
</style>

<template>
  <div>
    <!-- <layout-header role="seller" /> -->
    <div class="publish-product">
      <!-- <my-wrapper> -->
      <page-wrapper title="发布产品">
        <div class="publish-product-inner">
          <div class="publish-product-title">选择类目</div>
          <switch-cate />
        </div>
      </page-wrapper>
      <!-- </my-wrapper> -->
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import LayoutHeader from "@/layout/components/layout-header";
import switchCate from "./components/switch-cate";
export default {
  name: "seller-product-publish",
  components: { switchCate, LayoutHeader },
  data() {
    return {
      keyword: "",
    };
  },
};
</script>
